import {checkIfSafari} from './checkIfSafari';
import {checkIfIOS} from './checkIfIOS';

export const checkIfSafariOrIOS = () => {
    return checkIfIOS() || checkIfSafari();
};
